module.exports = __webpack_public_path__ + "d96f245a62c5f26d621ff88ab029250d.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/Foto_Manja_Herrmann-8386_klein.jpg
// module id = 601
// module chunks = 0